import {createRoot, hydrateRoot} from 'react-dom/client';
import TeamAndContact from '../pages/TeamAndContact/TeamAndContact'
import "../index.css";
import "../pages/TeamAndContact/TeamAndContact.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<TeamAndContact {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <TeamAndContact {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).TeamAndContactVC = {mount, hydrate, unmount}